<template>
    <div class="text-center">
        <v-dialog v-model="modalClose" width="35%">
            <v-card>
                <v-card-title
                    class="headline red lighten-2"
                    primary-title>
                    <span style="color: white">Check Recently Updates Back</span>
                </v-card-title>
                <v-card-text>
                    <v-container fluid class="p-0 mt-10">
                        <p class="modal-label">Run Sync from these date ranges:</p>
                        <v-row>
                            <v-col cols="auto" class="d-flex">
                                <v-icon class="mr-3">mdi-calendar</v-icon>
                                <v-datetime-picker
                                    v-model="startDate"
                                    timeFormat="HH:mm:ss"
                                    label="From Date">
                                </v-datetime-picker>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" class="d-flex">
                                <v-icon class="mr-3">mdi-calendar</v-icon>
                                <v-datetime-picker
                                    v-model="endDate"
                                    timeFormat="HH:mm:ss"
                                    label="To Date">
                                </v-datetime-picker>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <small class="text-danger">{{ errors.join(',') }}</small>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        @click="$emit('modalClose')">
                        Cancel
                    </v-btn>
                    <v-btn
                        small
                        color="primary"
                        :disabled="isProcessing"
                        @click="submit">
                        <span v-if="isProcessing">
                            <v-progress-circular
                                    indeterminate
                                    size="12"
                                    width="2"
                                    color="error darken-3">
                            </v-progress-circular>
                            Checking Updates...
                        </span>
                        <span v-else>Check Updates</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { EventBus } from '../../../event-bus.js'
import moment from 'moment';

export default {
    props: {
        integration: {
            type: Number
        }
    },

    data: function() {
        return {
            modalClose: true,
            startDate: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
            endDate: moment().format('YYYY-MM-DD HH:mm:ss'),
            errors: [],
            isProcessing: false
        }
    },

    watch: {
        modalClose(newVal, oldVal) {
            if (newVal != oldVal) {
                this.$emit('modalCLose')
            }
        }
    },

    methods: {
        submit() {

            if (this.isProcessing) {
                return;
            }

            if(this.dateChecker(this.startDate, this.endDate)) {
                this.errors.push('Please check start/end dates. Make sure start date is before end date')
                return;
            }

            this.isProcessing = true

            this.errors = [];

            console.log("the start date: ", this.startDate);
            console.log("the end date: ", this.endDate);

            let data = {
                'integration_id': this.integration,
                'date_start':  moment(this.startDate).format('YYYY-MM-DD HH:mm:ss'),
                'date_end':  moment(this.endDate).format('YYYY-MM-DD HH:mm:ss')
            }

            this.$http.post('/api/sync/check-updates', data)
            .then( ({ data }) => {
                console.log("the data is :", data)
                this.$emit('modalClose');
                EventBus.$emit('show-success', data?.message ?? 'Successfully check updates back.');
                this.isProcessing = false
            })
            .catch( err => {
                this.$emit('modalClose');
                EventBus.$emit('show-error', err);
                this.isProcessing = false
            })
        },

        dateChecker(start, end) {
            return moment(start).isSameOrAfter(end);
        }
    }
}
</script>
